import React from 'react';
import PropTypes from 'prop-types';
import FAQLayout from '../../components/faq/faq-layout';
import FAQOverviewPage from '../../components/faq/faq-overview-page';
import '@glowforge/ui-common/initializers/contentful-page';

import { getFaqPage } from '../../api/contentful';

const FaqPage = ({ page }) => {
  const { title, introText, faqSectionList } = page;

  return (
    <FAQLayout faqSectionList={faqSectionList}>
      <FAQOverviewPage
        title={title}
        introText={introText}
        faqSectionList={faqSectionList} />
    </FAQLayout>
  );
};

FaqPage.getInitialProps = async () => {
  const page = await getFaqPage();
  return { page };
};

FaqPage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  page: PropTypes.shape({
    title: PropTypes.string,
    introText: PropTypes.string,
    faqSectionList: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string,
      questions: PropTypes.array,
    })),
  }).isRequired,
};

export default FaqPage;
